// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const OrganizationIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="m15.66 8.14-.01-.02v-4.6c0-1.11-.9-2.02-2.03-2.02H9.94c-1.12 0-2.03.9-2.03 2.02v.85c0 .19-.15.34-.33.34H3.74c-1.11 0-2.02.9-2.02 2.02v13.75c0 1.11.9 2.02 2.02 2.02h11.58c.19 0 .34-.15.34-.33z"
        clipRule="evenodd"
        opacity=".5"
      />
      <path
        fillRule="evenodd"
        d="M20.26 8.13h-2.84c-.18 0-.33.15-.33.33v13.7c0 .2.15.34.33.34h2.84c1.11 0 2.02-.9 2.02-2.02V10.15c0-1.11-.9-2.02-2.02-2.02"
        clipRule="evenodd"
      />
      <path d="m10.9 10.3.16-.02c.45-.08.74-.52.66-.97-.09-.46-.53-.75-.97-.66-.45.09-.75.53-.66.97.07.4.42.68.81.68m-.16 2.4c-.45.09-.74.53-.65.98.08.39.43.66.81.66l.17-.01c.44-.1.74-.53.65-.98-.1-.46-.53-.74-.98-.65m.16 5.61.16-.01c.45-.09.74-.52.66-.97v-.01c-.09-.45-.53-.75-.97-.66-.45.09-.75.53-.66.98.07.4.42.67.81.67M6.48 10.3l.16-.02c.44-.08.74-.52.65-.97-.08-.46-.52-.75-.97-.66s-.74.53-.65.97c.07.4.42.68.8.68m-.15 2.4c-.45.09-.74.53-.65.98.08.39.42.66.8.66l.17-.01c.45-.1.74-.53.65-.98-.09-.46-.53-.74-.97-.65m.16 5.61.16-.01c.44-.09.74-.52.65-.97v-.01c-.08-.45-.52-.75-.97-.66s-.74.53-.65.98c.07.4.42.67.8.67" />
    </g>
  </SvgIcon>
);

export default OrganizationIcon;
